import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { CoreModule } from 'src/app/_core/core.module';
import { UserModule } from 'src/app/_user/user.module';

import { AppRoutingModule } from 'src/app/app-routing.module';
import { LayoutComponent } from 'src/app/_core/components/layout/layout.component';
import { GraphQLModule } from './_core/graphql.module';

@NgModule({
    imports: [
        CoreModule.forRoot(),
        UserModule.forRoot(),
        AppRoutingModule,
        BrowserModule,
        GraphQLModule
    ],
    bootstrap: [LayoutComponent],
    providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class AppModule {
}
